import { createSelector } from 'reselect';
import formatFacility from '../../utils/store/formatFacility';

const getNearbyFacilitiesFromState = (state) => (state.content && state.content.nearbyFacilities) || {};

export const getNearbyFacilities = createSelector(
	getNearbyFacilitiesFromState,
	(nearbyFacilities) => {
		if (!nearbyFacilities.facilityCollection || !nearbyFacilities.facilityCollection.collection) {
			return null;
		}
		
		const formatedNearbyFacilities = nearbyFacilities.facilityCollection.collection.map(facility => formatFacility(facility));
		
		return {
			...nearbyFacilities,
			nearbyCities: nearbyFacilities.nearbyCities || [],
			facilityCollection: {
				...nearbyFacilities.facilityCollection,
				collection: formatedNearbyFacilities
			}
		};
	},
);

export const getNearbyCities = createSelector(
	getNearbyFacilitiesFromState,
	(nearbyFacilities) => nearbyFacilities.nearbyCities || []
);
